import { useNavigate } from 'react-router-dom';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { MenuIcon } from "../../pages/Utils";
import { useAuth } from '../../authContext/AuthContext';
import { Noti } from '../Noti/toast';
import './style.scss';

const Header = ({ onMenuClick }: any) => {
    const { logout, user } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        Noti('success', 'Logout success', 3000);
        navigate('/login');
    };

    return (
        <header className="main-header">
            <div className="header-logo">
                <div className="sidebar-logo">M</div>
                <h1>Meteora Pay</h1>
            </div>
            <div className="header-actions">
                {user && (
                    <div className="user-info">

                        <span className="user-name">
                            <UserOutlined className="user-icon" /> {''}
                            {user.name}
                        </span>
                        <Button
                            type="text"
                            icon={<LogoutOutlined />}
                            onClick={handleLogout}
                            className="logout-button"
                        >
                            Logout
                        </Button>
                    </div>
                )}
                <button onClick={onMenuClick} className="mobile-menu-button">
                    <MenuIcon />
                </button>
            </div>
        </header>
    );
};

export default Header;